export default {
  product: [
    {
      label: '射频及微波',
      type: 0,
      list: [
        {
          img: require('@/assets/images/product/product_07.jpg'),
          title: '自组网数据链系统',
          id: 0,
          html: [
            {
              img: require('@/assets/images/product/product_07.jpg')
            },
            {
              title: '自组网数据链系统'
            },
            `<b>自组网数据链系统可完成多个控制节点之间以无中心的方式进行自组网，例如用于完成无人机之间的数据通信任务。</b><br>
            </br>
            <b>1. 可提供当前状态下网络的拓扑结构信息；</b><br>
            <b>2. 可实现任意两个无人机间以全连接的方式进行数据的实时交换；</b><br>
            <b>3. 具备抗毁自愈能力，任意节点损毁不影响网络正常通信，具有强抗毁能力；节点可以自由入网、退网，不影响网络性能。</b><br>
            </br>
            ◎ 供电电压：12V；<br>
            ◎ 发射功率：18dBm；<br>
            ◎ 平均功耗：6W；<br>
            ◎ 重量：41g；<br>
            ◎ 尺寸：60*51*4.5(mm)；<br>
            ◎ 组网总延迟：50ms；<br>
            ◎ 最大可支持节点数：16；<br>
            ◎ 接口：RS422（可定制）；<br>
            ◎ 通信距离：1km（可定制）；<br>
            ◎ 单用户数据速率：51.2kbps（可定制）；<br>
            ◎ 状态显示：可动态显示网络拓扑；<br>
            ◎ 管理软件：可对电台的信道进行设置。<br>`,
            '<a href="/user/test/xxxx.txt" download="文件名.txt"  style="color: #1e50ae;text-align:center;display: block;"> >>>>>>>>>>Spec Download<<<<<<<<<< </a>'
          ]
        },
        {
          img: require('@/assets/images/product/product_06.jpg'),
          title: '微型频谱监测系统',
          id: 1,
          html: [
            {
              img: require('@/assets/images/product/product_06.jpg')
            },
            {
              title: '微型频谱监测系统'
            },
            `<b>本频谱检测系统通过网口与计算机进行指令和数据交互，实现30MHz～6GHz信号的频谱监测，同时支持高精度GPS授时。可以通过网口设置监测设备的扫描宽度、起始频率、终止频率、带宽、RBW值、参考电平等参数；可以设置监测模块进入实时工作模式；可触发后记录信号、实时分析和IQ数据采集。支持外部标准时钟输入。对FFT数据进行预处理，具有能量检测功能，能检测到信号时域上的上升沿和下降沿。</b><br>
            </br>
            <b>产品特征：</b><br>
            </br>
            ◎ 频率范围：30MHz至6GHz；<br>
            ◎ 工作模式：实时工作模式、扫频工作模式；<br>
            ◎ IQ数据采集：250KHz到50MHz可变；<br>
            ◎ 中频带宽：支持50MHz、10MHz、5MHz、1MHz可调；<br>
            ◎ 频率稳定度：0.5ppm/年（支持GPS授时，支持外部参考时钟）；<br>
            ◎ 频率分辨率：支持7.5KHz、15KHz、22.5KHz、30KHz可调；<br>
            ◎ 频率Span：5Hz至最大带宽；<br>
            ◎ 幅度范围：+10dBm到DANL（显示平均噪声电平）；<br>
            ◎ 绝对精度：±2dB@25℃；<br>
            ◎ 动态范围：90dB；<br>
            ◎ 对外接口：网口、串口；<br>
            ◎ 内部存储：DDR3，8GB。<br>`,
            '<a href="/user/test/xxxx.txt" download="文件名.txt"  style="color: #1e50ae;text-align:center;display: block;"> >>>>>>>>>>Spec Download<<<<<<<<<< </a>'
          ]
        },
        {
          img: require('@/assets/images/product/product_05.jpg'),
          title: '超快速AGC射频前端',
          id: 2,
          html: [
            {
              img: require('@/assets/images/product/product_05.jpg')
            },
            {
              title: '超快速AGC射频前端'
            },
            `<b>小型化宽带收发射频模块，发射功率5W；为满足多套设备同时工作且不被干扰的场景需求，实现接收下变频功能；具备高动态范围的快速AGC功能，信号输入功率范围+10dBm~-100dBm，AGC响应时间小于40us；具备驻波保护功能，在未接天线情况下模块进入自保护模式；具备过流、过温保护功能；具备过功率保护功能，接收信号高于10dBm以上模块进入自保护模式；收发控制由一路TTL电平完成。</b><br>
            </br>
            <b>产品特征：</b><br>
            </br>
            ◎ 通信体制：TDD时分双工模式；<br>
            ◎ 工作频段：1340MHz~1500MHz；(可定制)<br>
            ◎ 发射P1dB：≥5W；(可定制)<br>
            ◎ 发射平坦度：≤±1.5dB；<br>
            ◎ 发射模式功耗：≤20W；<br>
            ◎ 接收中频：360MHz±20MHz；<br>
            ◎ 最大接收功率：+10dBm；<br>
            ◎ 动态范围：110dB；<br>
            ◎ 接收模式功耗：≤6W；<br>
            ◎ 接收中频输出功率：-5~-40dBm之间；<br>
            ◎ 接收中频平坦度：≤±1dB；<br>
            ◎ 输入驻波： ≤1.5；<br>
            ◎ 噪声系数：≤5dB。<br>`,
            '<a href="/user/test/xxxx.txt" download="文件名.txt"  style="color: #1e50ae;text-align:center;display: block;"> >>>>>>>>>>Spec Download<<<<<<<<<< </a>'
          ]
        },
        {
          img: require('@/assets/images/product/product_04.jpg'),
          title: '功放模块（<50W ）',
          id: 3,
          html: [
            {
              img: require('@/assets/images/product/product_04.jpg')
            },
            {
              img: require('@/assets/images/product/product_08.jpg')
            },
            {
              title: '功放模块-可定制'
            },
            `<b>-->10W~50W功放模块<--</b><br>
            </br>
            <b>产品特征：</b><br>
            </br>
            ◎ 频率范围：1.2GHz~1.7GHz(频段可定制)；<br>
            ◎ 输出P1dB：10W~50W(依据需求而定)；<br>
            ◎ 增益：≥40dB(依据输出功率而定)；<br>
            ◎ 平坦度：≤±2dB；<br>
            ◎ 供电：28V、5V；<br>
            ◎ 具备空载抗烧毁功能(30分钟)；<br>
            ◎ 具备驻波保护功能；<br>
            ◎ 具备过温保护功能；<br>
            ◎ 具备过流保护功能；<br>
            ◎ TTL发射使能控制；<br>`,
            '<a href="/user/test/xxxx.txt" download="文件名.txt"  style="color: #1e50ae;text-align:center;display: block;"> >>>>>>>>>>Spec Download<<<<<<<<<< </a>'
          ]
        }
      ]
    },
    {
      label: '天线产品',
      type: 1,
      list: [
        {
          img: require('@/assets/images/product/product_02.jpg'),
          title: '智能终端天线',
          id: 4,
          html: [
            {
              img: require('@/assets/images/product/product_02.jpg')
            },
            {
              img: require('@/assets/images/product/product_09.jpg')
            },
            {
              title: '智能终端天线'
            },
            `<b>我司可提供天线种类有WiFi天线、GPS天线、5G天线等。工作频段：2400-2500MHz，5150-5850MHz，1575.42MHz，600-960MHz/1710-6000MHz。形式包括胶棒天线，外置天线，陶瓷天线，吸盘天线，贴片天线,FPC天线等；PCB天线线极化，增益：0dBi,3dBi，6dBi，7dBi。</b><br>
            ◎请咨询参考我司天线产品手册--->`,
            '<a href="/user/test/xxxx.txt" download="文件名.txt"  style="color: #1e50ae;text-align:center;display: block;"> >>>>>>>>>>Spec Download<<<<<<<<<< </a>'
          ]
        },
        {
          img: require('@/assets/images/product/product_01.jpg'),
          title: '车载智能天线',
          id: 5,
          html: [
            {
              img: require('@/assets/images/product/product_01.jpg')
            },
            {
              img: require('@/assets/images/product/product_10.jpg')
            },
            {
              title: '车载智能天线'
            },
            `<b>我司可提供车载天线包括外置、内置多合一天线，高精度定位天线，鲨鱼鳍天线，车载无线充电天线。工作频段：3G/4G/GPS，GPS L1/L2， BD B1/B2/B3 ，Glonass L1/L2。右旋圆极化，低噪放LNA：28dB。</b><br>
            ◎请咨询参考我司天线产品手册--->`,
            '<a href="/user/test/xxxx.txt" download="文件名.txt"  style="color: #1e50ae;text-align:center;display: block;"> >>>>>>>>>>Spec Download<<<<<<<<<< </a>'
          ]
        },
        {
          img: require('@/assets/images/product/product_11.jpg'),
          title: '基站类天线',
          id: 6,
          html: [
            {
              img: require('@/assets/images/product/product_11.jpg')
            },
            {
              img: require('@/assets/images/product/product_12.jpg')
            },
            {
              title: '基站类天线'
            },
            `<b>-->可提供包括5G宏基站天线振子、微基站及CPE天线、5G毫米波射频前端模组等。工作频段：2600MHz，3500MHz，4800MHz，698-960MHz/1710-2170MHz。增益：2dBi，4dBi，7dBi，10dBi，16dBi ,20dBi。<--</b><br>
            ◎请咨询参考我司天线产品手册--->`,
            '<a href="/user/test/xxxx.txt" download="文件名.txt"  style="color: #1e50ae;text-align:center;display: block;"> >>>>>>>>>>Spec Download<<<<<<<<<< </a>'
          ]
        },
        {
          img: require('@/assets/images/product/product_03.jpg'),
          title: '天线定制服务',
          id: 7,
          html: [
            {
              img: require('@/assets/images/product/product_03.jpg')
            },
            {
              title: '天线定制服务'
            },
            `<b>-->坤恒科技提供终端天线定制服务，包括：GPS天线、组合天线、阵列天线、低频天线、定位精密测量天线、WIFI天线、5G天线、4G天线等，具体请咨询info@kun-heng.com。<--</b><br>
            </br>
            <b>定制服务需提供以下信息：</b><br>
            </br>
            ◎应用领域：<br>
            ◎项目日程：<br>
            ◎年用量：<br>
            ◎通信协议：<br>
            ◎工作频段：<br>
            ◎极化方式：<br>
            ◎天线增益：<br>
            ◎波瓣宽度：<br>
            ◎安装方式：<br>
            ◎工作温度：<br>
            ◎防水等级：<br>
            ◎工作湿度：<br>
            ◎尺寸要求：<br>
            ◎连接器类型：<br>
            ◎电缆类型：<br>
            ◎电缆长度：<br>
            ◎安装方式：<br>
            ◎其它备注请发邮件或直接联系我司业务代表：<br>`,
            '<a href="/user/test/xxxx.txt" download="文件名.txt"  style="color: #1e50ae;text-align:center;display: block;"> >>>>>>>>>>Spec Download<<<<<<<<<< </a>'
          ]
        }
      ]
    },
    {
      label: '高性能计算',
      type: 2,
      list: [
        {
          img: require('@/assets/images/product/product_11.png'),
          title: '边缘计算',
          id: 8,
          html: [
            {
              img: require('@/assets/images/product/product_11.png')
            },
            {
              title: '边缘计算板卡及盒子'
            },
            {
              table: {
                thFontSize: 8,
                thcolor: '#71652a',
                thbackground: '#303030',
                tdFontSize: 8,
                tdcolor: '#00008b',
                cols: [ // 表格列配置
                  {
                    key: 'CAM',
                    label: '摄像头',
                    width: 130,
                    tdFontSize: 8,
                    tdcolor: '#00c08b'
                  },
                  {
                    key: 'FLASH',
                    label: '存储器',
                    width: 80
                  },
                  {
                    key: 'CPU',
                    label: '处理器',
                    width: 85
                  },
                  {
                    key: 'OS',
                    label: '操作系统',
                    width: 80
                  },
                  {
                    key: 'Delay',
                    label: '实时抓拍时间',
                    width: 60
                  },
                  {
                    key: 'Dist',
                    label: '识别率',
                    width: 70
                  },
                  {
                    key: 'DB',
                    label: '数据库',
                    width: 90
                  },
                  {
                    key: 'INP',
                    label: '输入协议',
                    width: 75
                  },
                  {
                    key: 'ORP',
                    label: '压缩协议',
                    tdFontSize: 8,
                    width: 122
                  }
                ],
                tableData: [
                  { // 表格数据
                    CAM: '4路1080P/4路4M/2路4K',
                    FLASH: '2G/32G',
                    CPU: 'RK3399+RK1808',
                    OS: 'Linux 16.14',
                    Delay: '<1秒',
                    Dist: '>99%',
                    DB: '100000',
                    INP: 'ONVIF/RTSP/GB28181',
                    ORP: 'H.264/H.265'
                  }
                ]
              }
            },
            `<b>本公司智能盒采用高性能人工智能处理器，结合先进的深度学习算法，实现动态人脸抓拍。处理速度快、精度高，可实现多路视频流同时处理。此产品可广泛应用于：<br>
            智慧校园——刷脸门禁如：图书馆、实验室，教室内实现刷脸点名；<br>
            银行——刷脸认证、刷脸支付、刷脸取款等；<br>
            社区——刷脸门禁进入小区，刷脸入户等；<br>
            高戒备场所——高危人员监控等；</b><br>
            </br>
            <b>产品特点：</b><br>
            </br>
            ◎1.高性能处理器使得处理速度快、精度高；<br>
            ◎2.温度适应范围宽，低温至-30℃，高温可达70℃；<br>
            ◎3.产品尺寸小可以前端化，数据实时处理；<br>
            ◎4.可内置扩展4G和WIFI模块；<br>
            ◎5.支持多路视频接入同时处理；<br>
            ◎6.支持连接市面上大多数普通网络摄像机，连接方式简单易操作；<br>
            ◎7.标准接口丰富，可适用多种应用场合；<br>
            ◎8.支持创建不同属性的人脸库或者特点识别库，以用于不同场景；<br>`,
            '<a href="/user/test/xxxx.txt" download="文件名.txt"  style="color: #1e50ae;text-align:center;display: block;"> >>>>>>>>>>Spec Download<<<<<<<<<< </a>'
          ]
        },
        {
          img: require('@/assets/images/product/product_13.jpg'),
          title: '高性能加速卡',
          id: 9,
          html: [
            {
              img: require('@/assets/images/product/product_13.jpg')
            },
            {
              title: '高性能加速卡'
            },
            `<b>-->KHU2K系列FPGA加速卡采用Xilinx Ultrascale+16nmVU3P芯片,提供服务器标准PCle3.0x16通道, 2*100GE网络通道,12*25Gbps或者3*100Gbps板间网络通道,最大外挂32GB内存,具有高性能计算能力及大带宽数据连接。FPGA提供强大的可编程,并行处理能力,适用于多种类型的硬件加速业务,比如网络处理、人工智能、视频处理、基因测序等。用最高能效比加速数据中心业务。<--</b><br>
            </br>
            <b>产品特点：</b><br>
            </br>
            ◎赛灵思 Ultrascle+16nm VU3P设计；<br>
            ◎支持安全认证,支持芯片级加密；<br>
            ◎高可靠性,支持过温/过流/过功率保护；<br>
            ◎支持PCle在线升级；<br>
            ◎支持多卡Firefly直连,带宽支持12*25Gbps或者3*100Gbps；<br>
            ◎1PPS SMA时钟同步；<br>
            ◎可选择被动散热/主动散热；<br>
            ◎最大功率75W,无需外接电源；<br>`,
            '<a href="/user/test/xxxx.txt" download="文件名.txt"  style="color: #1e50ae;text-align:center;display: block;"> >>>>>>>>>>Spec Download<<<<<<<<<< </a>'
          ]
        },
        {
          img: require('@/assets/images/product/product_14.jpg'),
          title: '定制产品ASIC化',
          id: 10,
          html: [
            {
              img: require('@/assets/images/product/product_14.jpg')
            },
            {
              title: '定制产品ASIC化'
            },
            'FPGA（Field－Programmable Gate Array），即现场可编程门阵列，是在PAL、GAL、CPLD等可编程器件的基础上进一步发展的产物。它是作为专用集成电路(ASIC) 领域中的一种半定制电路而出现的，既解决了定制电路的不足，又克服了原有可编程器件门电路数有限的缺点。它是当今数字系统设计的主要硬件平台，其主要特点就是完全由用户通过软件进行配置和编程，从而完成某种特定的功能，且可以反复擦写。在修改和升级时，不需额外地改变PCB 电路板，只是在计算机上修改和更新程序，使硬件设计工作成为软件开发工作，缩短了系统设计的周期，提高了实现的灵活性并降低了成本。',
            'ASIC（Application Specific Integrated Circuit），即专用集成电路，是一种为专门目的而设计的集成电路。是指应特定用户要求和特定电子系统的需要而设计、制造的集成电路。ASIC的特点是面向特定用户的需求， ASIC分为全定制和半定制。亮点在于专用，量身定制所以执行速度较快。',
            '我公司依靠FPGA设计积累的技术优势，依托SMIC先进的工艺制程，可以支持28nm以上ASIC及SOC设计成果的芯片级转化。',
            '详细项目合作欢迎来电来信洽谈。 ---> info@kun-heng.com'
          ]
        },
        {
          img: require('@/assets/images/product/product_22.jpg'),
          title: 'SAS高速背板扩展',
          id: 11,
          html: [
            {
              img: require('@/assets/images/product/product_22.jpg')
            },
            {
              title: 'SAS高速背板扩展'
            },
            'SAS Expander可以认为硬盘交换机，通过这个装置，将很多硬盘连接在一起，并提供一个对外连接接口到服务器。SAS扩展器是一种较新的存储技术，可使SAS控制器卡的存储容量最大化。',
            'KH22EX产品系列采用12Gb Expander芯片（BCM），支持12Gb SAS硬盘，能最大发挥产品性能。该产品系列最大支持24盘位，以此可灵活构建12-72盘位服务器，存储等产品方案。具备SPGIO、分时启动、风扇温度控制等强大的功能特性，和各类HBA卡，RAID卡具备良好的兼容性。',
            '详细项目合作欢迎来电来信洽谈。 ---> info@kun-heng.com'
          ]
        },
        {
          img: require('@/assets/images/product/product_20.jpg'),
          title: '高性能通讯板卡',
          id: 12,
          html: [
            {
              img: require('@/assets/images/product/product_20.jpg')
            },
            {
              title: '国产化通讯板卡'
            },
            `<b>近年中国厂商已成功研制自主可控交换机，为内循环提供保障。公司在2019年完成了此国产化平台的技术公关，结合历年来自研所积累的深厚的软件协议技术经验，旨在服务有此类需求的终端客户，提供自主，可控，安全，可靠的一系列产品。同时公司承接面向国产化应用的产品定制服务，包括安全通讯、存储系列板卡。</b><br>`,
            {
              table: {
                thFontSize: 8,
                thcolor: '#47c1c2',
                thbackground: '#303030',
                tdFontSize: 8,
                tdcolor: '#00008b',
                cols: [ // 表格列配置
                  {
                    key: 'PN',
                    label: 'Part Number',
                    width: 180,
                    tdFontSize: 8,
                    tdcolor: '#8b1c08'
                  },
                  {
                    key: 'DSCP',
                    label: 'Description',
                    width: 612
                  }
                ],
                tableData: [
                  { // 表格数据
                    PN: 'KHCPCIE-8WX-24GEI Card',
                    DSCP: '国产化三层交换机8万兆光+24GE。'
                  },
                  {
                    PN: 'KHCPCIE-8WX-24GEM Card',
                    DSCP: '国产化三层交换机8万兆光口+24GE。'
                  },
                  {
                    PN: 'KHCPCI-4GX-24GE Card',
                    DSCP: 'CPCI接口卡，二层，4千兆光口，24个千兆电口。'
                  },
                  {
                    PN: 'KHCPCIE-4GX-24GE Card',
                    DSCP: 'CPCIE接口卡，二层，4千兆光，24个千兆电口。'
                  },
                  {
                    PN: 'KHCPCI-4WX-24GE Card',
                    DSCP: 'CPCI接口卡，三层，4万兆光，24个千兆电口。'
                  },
                  {
                    PN: 'KHCPCIE-4WX-24GE Card',
                    DSCP: 'CPCIE接口卡，三层，4万兆光，24个千兆电口。'
                  },
                  {
                    PN: 'KHVPX-4WX-24GE Card',
                    DSCP: 'VPX接口卡，三层，4万兆光，24个千兆电口。'
                  }
                ]
              }
            },
            '<a href="/user/test/xxxx.txt" download="文件名.txt"  style="color: #1e50ae;text-align:center;display: block;"> >>>>>>>>>>下载资料 || 联系我们<<<<<<<<<< </a>'
          ]
        }
      ]
    },
    {
      label: '机械加工设计',
      type: 51,
      list: [
        {
          img: require('@/assets/images/product/cnc2.jpg'),
          title: '模具设计及制造',
          id: 0,
          html: [
            {
              img: require('@/assets/images/product/cnc2.jpg')
            },
            {
              img: require('@/assets/images/product/cnc3.jpg')
            },
            {
              title: '模具设计及制造'
            },
            `<b>-->公司承接模具设计和制造，尤其擅长重力模具设计和成型！以上为产品能力展示，欢迎来电来信洽谈！请联系：info@kun-heng.com<--</b><br>`,
            '<a href="/user/test/xxxx.txt" download="文件名.txt"  style="color: #1e50ae;text-align:center;display: block;"> >>>>>>>>>>Spec Download<<<<<<<<<< </a>'
          ]
        },
        {
          img: require('@/assets/images/product/cnc4.jpg'),
          title: '机械加工及铸造',
          id: 52,
          html: [
            {
              img: require('@/assets/images/product/cnc4.jpg')
            },
            {
              img: require('@/assets/images/product/cnc5.jpg')
            },
            `<b>-->公司各种机械加工设计与制造，尤其擅长重力铸造产品！以上为产品能力展示，欢迎来电来信洽谈！请联系：info@kun-heng.com<--</b><br>`,
            '<a href="/user/test/xxxx.txt" download="文件名.txt"  style="color: #1e50ae;text-align:center;display: block;"> >>>>>>>>>>Spec Download<<<<<<<<<< </a>'
          ]
        }
      ]
    }
  ]
}



// WEBPACK FOOTER //
// ./src/datas/productList.js